import { t } from '../../logical/type-presets.js';
import { createFilter } from './create.js';

export const booleanFilter = [
  createFilter({
    name: 'isChecked',
    self: t.boolean.instance(),
    args: [],
    label: '已选中',
    shortString: () => '：已选中',
    impl: value => {
      return !!value;
    },
    defaultValue: () => true,
  }),
  createFilter({
    name: 'isUnchecked',
    self: t.boolean.instance(),
    args: [],
    label: '未选中',
    shortString: () => '：未选中',
    impl: value => {
      return !value;
    },
    defaultValue: () => false,
  }),
];
